<template>
    <div class="overflow-x-hidden relative">
        <section
            class="vision-mission-section text-center grid flex flex-wrap justify-content-center align-items-center  py-6 md:px-4 md:px-6 relative">
            <div class="background-image"
                    :style="{ backgroundImage: `url('${bgUrl}')`, zIndex: 0 }">
                </div>
            <div class="col-10 pt-4 relative">
                <span class="badge mb-2">Vision & Mission</span>
                <h2 class="mb-2 LandingPage-Title">
                    Guiding principles that drive our commitment to educational excellence
                </h2>

            </div>
            <div class="container px-4 md:px-6 col-11 py-6 relative">
                <div class="grid ">
                    <!-- Vision -->
                    <div class="col-12 lg:col-6">
                        <div class="vision-content px-4 " v-animateonscroll="{ enterClass: 'animate-enter slide-in-left' }">
                            <div
                                class="feature-icon w-4rem h-4rem flex align-items-center justify-content-center  mb-4 border-round-lg">
                                <i class="text-blue-500 text-2xl pi pi-verified"></i>

                            </div>
                            <h2 class="H5-SemiBold text-left mb-2 text-white">Our Vision</h2>
                            <p class="text-left Label leading-relaxed md:pr-4 text-white">
                                To become Sri Lanka's leading educational platform, making quality learning accessible
                                to every student across the island, while empowering tutors to share their knowledge,
                                grow their careers, and shape the future of education.
                            </p>
                        </div>
                    </div>

                    <!-- Mission -->
                    <div class="col-12 lg:col-6">
                        <div class="mission-content px-4" v-animateonscroll="{ enterClass: 'animate-enter slide-in-right' }">
                            <div
                                class="feature-icon w-4rem h-4rem flex align-items-center justify-content-center mb-4 border-round-lg">
                                <i class="text-blue-500 text-2xl pi pi-verified"></i>
                            </div>
                            <h2 class="H5-SemiBold text-left mb-2 text-white">Our Mission</h2>
                            <div class="mission-list">
                                <div v-for="(mission, index) in missions" :key="index"
                                    class="flex align-items-start gap-2 pb-2">
                                    <div
                                        class="mission-number text-white  flex align-items-center justify-content-center Label flex-shrink-0">
                                        {{ mission.number }}.
                                    </div>
                                    <p class="text-left text-white  Label mt-0 mb-0">{{ mission.text }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
import { usePublicUrl } from "@/utils/getPublicUrl"
const bgUrl = usePublicUrl("public/beach.jpg");
const missions = [
    {
        number: "01",
        text: "Connect students with the right tutors through a simple, reliable, and engaging platform."
    },
    {
        number: "02",
        text: "Empower tutors with recognition, visibility, and meaningful teaching opportunities."
    },
    {
        number: "03",
        text: "Use smart technology to advance education and create a seamless, one-step learning experience."
    },
    {
        number: "04",
        text: "Build trust by offering a safe, secure, and dependable tutoring space for all."
    }
];
</script>
<style scoped>
.background-image {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 90%; /* Keep the image itself slightly transparent */
  z-index: 1; /* Ensure the image is behind the content */
}

/* New: Create a pseudo-element to hold the blur and color overlay */
.background-image::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* 1. Add the semi-transparent black overlay */
  background: rgba(0, 0, 0, 0.25);
  /* 2. Add the blur effect */
  backdrop-filter: blur(4px);
  
  /* Ensure this overlay is above the image but below the main content */
  z-index: 2; 
}
.feature-icon {
    background-color: #F1FAF8;
}
</style>